import { CountryRendering } from '@/primary/country/CountryRendering';
import { Feature } from 'ol';
import { lightGrey, greenShade42, greenShade60 } from '@/primary/webmapping/country/style/CountryStyle';
import { GREEN_SHADE_42, GREEN_SHADE_60 } from '@/primary/Color';
import { MultiPolygon } from 'ol/geom';
import { GeoJSON } from 'ol/format';

const toStyle = (color: string) => (color === GREEN_SHADE_42 ? greenShade42 : color === GREEN_SHADE_60 ? greenShade60 : lightGrey);

export const createCountryFeature = (countryRenderingFeature: GeoJSON.Feature<GeoJSON.MultiPolygon, CountryRendering>) => {
  const countryFeature = new Feature({
    selectable: countryRenderingFeature.properties.selectable,
    geometry: new MultiPolygon(countryRenderingFeature.geometry.coordinates),
  });
  countryFeature.setId(countryRenderingFeature.properties.id);
  countryFeature.setStyle([toStyle(countryRenderingFeature.properties.color)]);
  return countryFeature;
};

export const updateCountryFeature = (countryFeature: Feature, countryRendering: CountryRendering): void => {
  const style = toStyle(countryRendering.color);
  countryFeature.set('selectable', countryRendering.selectable);
  countryFeature.setStyle([style]);
};
